<div id="receiver-confirm" class="parent">
  <div class="imgContainer">
    <img id="imageToDisplay" src="" alt="" />
  </div>

  <div class="accountDetailsSearchResult inner-modal">
    <div class="inner-modal-content">
      <div *ngIf="submit == 'confirm'"
        class="confirmSubmitRequest flex flex-column justify-center align-center text-center">
        <p class="para-title">
          Do we Submit Your family request for cash assistance?
        </p>

        <button class="ui button primary basic mt-4" (click)="submitRequestForAssistance()">
          Yes, Submit our request
        </button>
        <a class="mt-3 link" (click)="closeTheModal('cancel')">
          No, cancel request
        </a>

      </div>

      <div *ngIf="submit == 'success'" class="requestSuccess flex flex-column justify-center align-center text-center">
        <div class="modal-icon mb-4"><img src="../../../assets/images/svgs/checked.svg" alt="" /></div>
        <p class="para-title">
          Your request has been sent for assistance. You will get an alert once we
          find a helper.
        </p>

        <button class="ui button primary basic mt-4" (click)="closeTheModal('success')">
          Okay
        </button>
      </div>

      <div *ngIf="submit == 'failed'" class="requestSuccess flex flex-column justify-center align-center text-center">
        <div class="modal-icon"><img src="../../../assets/images/svgs/alert.svg" alt="" /></div>
        <p class="para-body">
          Your request could not be processed at the moment because you've made a request earlier
        </p>

        <button class="ui button negative basic mt-4" (click)="closeTheModal('cancel')">
          Close
        </button>
      </div>
    </div>
  </div>
</div>